import { Serializer as JSONAPISerializer } from 'jsonapi-serializer';

export const PersonalGreetingSerializer = new JSONAPISerializer('personal-greeting', {
  keyForAttribute: 'camelCase',
  attributes: ['id', 'subject', 'body', 'read'],
});
